import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';

export default function Confirm({ prevHook, prevStep, nextStep, nextHook = () => {}, updateState, formData }) {
  const [showPrevModal, setShowPrevModal] = useState(false);

  const [formFields, setFormFields] = useState({
    major_location_school_name_1: '',
    tax_return_files: [],
    major_location_establishment_year_1: '',
    major_location_no_of_students_1: '',
    major_location_monthly_fee_1: '',
    major_location_area_of_land_1: '',
    major_location_school_name_2: '',
    major_location_establishment_year_2: '',
    major_location_no_of_students_2: '',
    major_location_monthly_fee_2: '',
    major_location_area_of_land_2: '',
    major_location_school_name_3: '',
    major_location_establishment_year_3: '',
    major_location_no_of_students_3: '',
    major_location_monthly_fee_3: '',
    major_location_area_of_land_3: '',
    residential_colonies: '',
    facilities_availability: '',
    success_reason_of_school: '',
    school_board_type: '',
    crime_information_type: '',
    crime_information_details: '',
    pending_court_case_type: '',
    pending_court_case_details: '',
    land_possession_type: '',
    land_possession_details: ''
  });

  useEffect(() => {
    setFormFields((prevFields) => ({
      ...prevFields,
      ...formData
    }));
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prevData) => {
      const updated = {
        ...prevData,
        [name]: value
      };
      updateState(updated);
      return updated;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to submit this form?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#174d82',
      cancelButtonColor: '#eabb1b',
      confirmButtonText: 'Yes, submit it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Submitted data:", formFields);
        nextHook();
        Swal.fire('Submitted!', 'Your form has been submitted.', 'success');
      }
    });
  };
  // const handleFileChange = (e) => {
  //   const files = Array.from(e.target.files);
  //   if (files.length > 0) {
  //     setFormFields((prevFields) => ({
  //       ...prevFields,
  //       tax_return_files: files, // NOT .map(file => file.name)
  //     }));
  //   }
  // };


console.log("files")
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const updated = {
      ...formFields,
      tax_return_files: files,
    };
  console.log(files,"files")
    setFormFields(updated);
  
    // ✅ This is what pushes the file to global state!
    updateState({
      confirmFormDetails: updated
    });
  };


  const handlePrevious = () => {
    setShowPrevModal(true);
    prevHook(formFields);
  };

  const handlePrevConfirm = () => {
    setShowPrevModal(false);
    if (typeof prevStep === "function") {
      prevStep();
    }
  };

  return (
    <div className="container-fluid" id='msform'>
      <form onSubmit={handleSubmit}>
        <fieldset>
          <h2 className="fs-title">Other Major School</h2>

          <table className="table">
            <thead>
              <tr>
                <th>School Name</th>
                <th>Est. Year</th>
                <th>No. of Students</th>
                <th>Monthly Fee (INR)</th>
                <th>Area of Land (Acres)</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3].map(i => (
                <tr key={i}>
                  <td>
                    <input
                      type="text"
                      name={`major_location_school_name_${i}`}
                      value={formFields[`major_location_school_name_${i}`]}
                      onChange={handleChange}
                      placeholder={`School Name ${i}`}
                      className="form-control inp"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name={`major_location_establishment_year_${i}`}
                      value={formFields[`major_location_establishment_year_${i}`]}
                      onChange={handleChange}
                      placeholder={`Year ${i}`}
                      className="form-control inp"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name={`major_location_no_of_students_${i}`}
                      value={formFields[`major_location_no_of_students_${i}`]}
                      onChange={handleChange}
                      placeholder={`Students ${i}`}
                      className="form-control inp"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name={`major_location_monthly_fee_${i}`}
                      value={formFields[`major_location_monthly_fee_${i}`]}
                      onChange={handleChange}
                      placeholder={`Monthly Fee ${i}`}
                      className="form-control inp"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name={`major_location_area_of_land_${i}`}
                      value={formFields[`major_location_area_of_land_${i}`]}
                      onChange={handleChange}
                      placeholder={`Area ${i}`}
                      className="form-control inp"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="row">
            <div className="col-lg-6">
              <textarea
                name="residential_colonies"
                value={formFields.residential_colonies}
                onChange={handleChange}
                placeholder="Residential Colonies:"
                className="form-control"
              />
            </div>
            <div className="col-lg-6">
              <textarea
                name="facilities_availability"
                value={formFields.facilities_availability}
                onChange={handleChange}
                placeholder="Facilities Availability:"
                className="form-control"
              />
            </div>
          </div>

          <div className="mt-3">
            <textarea
              name="success_reason_of_school"
              value={formFields.success_reason_of_school}
              onChange={handleChange}
              placeholder="What do you think are the reasons for the success of a school in your area?"
              className="form-control"
            />
          </div>

          <div className='row'>
              <div className='col-12 col-sm-8 col-md-6 col-lg-6'>
              <label className='left-text'>
                  Which School Board is most prevalent in the area?:
                  <select
                    name="school_board_type"
                    value={formFields.school_board_type || ''}
                    onChange={handleChange}
                    className="landtype"
                  >
                    <option value="">Select School Board Type</option>
                    <option value="CBSE">CBSE</option>
                    <option value="ICSE">ICSE</option>
                    <option value="IB">IB</option>
                  </select>
                  
                </label>

              </div>
            </div>
  
            <div className='row'>
              <div className='col-12 col-sm-8 col-md-6 col-lg-6'>
                <div className="radio-count">
                  <label>
                    Have you ever been convicted of any crime involving actions contrary to the community standard of justice, honesty, or good morals?
                    <div>
                      <label>
                        <input
                          type="radio"
                          name="crime_information_type"
                          value="yes"
                          checked={formFields.crime_information_type === "yes"}
                          onChange={handleChange}
                        />
                        Yes
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="crime_information_type"
                          value="no"
                          checked={formFields.crime_information_type === "no"}
                          onChange={handleChange}
                        />
                        No
                      </label>
                    </div>
                  </label>
                </div>
  
                {formFields.crime_information_type === "yes" && (
                  <div className="radio-count">
                    <label>
                      If yes, please state nature and status:
                      <textarea
                        className='inp'
                        name="crime_information_details"
                        value={formFields.crime_information_details || ''}
                        onChange={handleChange}
                      />
                    </label>
                  </div>
                )}
              </div>
            </div>
  
            <div className="radio-count">
              <label>
                Is there any pending lawsuit, whether civil or criminal, of which you are accused?
                <div>
                  <label>
                    <input 
                      type="radio"
                      name="pending_court_case_type"
                      value="yes"
                      checked={formFields.pending_court_case_type === "yes"}
                      onChange={handleChange}
                    />
                    Yes
                  </label>
                  <label>
                    <input 
                      type="radio"
                      name="pending_court_case_type"
                      value="no"
                      checked={formFields.pending_court_case_type === "no"}
                      onChange={handleChange}
                    />
                    No
                  </label>
                </div>
              </label>
  
              {formFields.pending_court_case_type === "yes" && (
                <label>
                  Please provide details of the pending court case:
                  <textarea
                    className='inp'
                    name="pending_court_case_details"
                    value={formFields.pending_court_case_details || ''}
                    onChange={handleChange}
                  />
                 
                </label>
              )}
            </div>
  
            <div className="radio-count">
              <label>
                Is there any land dispute or any legal complications in the possession of the school land?
                <div>
                  <label>
                    <input 
                      type="radio"
                      name="land_possession_type"
                      value="yes"
                      checked={formFields.land_possession_type === "yes"}
                      onChange={handleChange}
                    />
                    Yes
                  </label>
                  <label>
                    <input 
                      type="radio"
                      name="land_possession_type"
                      value="no"
                      checked={formFields.land_possession_type === "no"}
                      onChange={handleChange}
                    />
                    No
                  </label>
                </div>
              </label>
  
              {formFields.land_possession_type === "yes" && (
                <label>
                  If yes, please provide details:
                  <textarea
                    className='inp'
                    name="land_possession_details"
                    value={formFields.land_possession_details || ''}
                    onChange={handleChange}
                    
                  />
                </label>
              )}
            </div>
            <div className="col-4">
              <label className="left-text">
                Please Select Files (PDF only):
                <input
                  type="file"
                  name="files[]"
                  className="form-control"
                  onChange={handleFileChange}
                  multiple // <- Important for selecting multiple files
                  accept="application/pdf" // <- Only allow PDFs
                />
              </label>
              {/* Show selected file names */}
              {formFields.tax_return_files && formFields.tax_return_files.length > 0 && (
              <div className="mt-2">
                <strong>Selected Files:</strong>
                <ul>
                  {formFields.tax_return_files.map((file, index) => (
                    <li key={index}>{file.name}</li>
                  ))}
                </ul>
              </div>
            )}
            </div>


          <div className="mt-4">
            <button className="previous action-button-previous" type="button" onClick={handlePrevious}>
              Previous
            </button>
            <button className="next action-button ms-3" type="submit">
              Submit
            </button>
          </div>
        </fieldset>
      </form>

      {/* Modal for going back */}
      <Modal show={showPrevModal} onHide={() => setShowPrevModal(false)} centered>
        <Modal.Header>
          <Modal.Title className="mb-0">Go Back Confirmation</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowPrevModal(false)} />
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to go back to the previous step?
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            onClick={() => setShowPrevModal(false)}
            style={{
              border: "none",
              background: "#eabb1b",
              borderRadius: '25px',
              padding: "10px 20px",
              fontWeight: "bold"
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handlePrevConfirm}
            style={{
              borderRadius: '25px',
              background: "#174d82",
              padding: "10px 17px",
              fontWeight: "bold"
            }}
          >
            Yes, Go Back
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
